import { Box, Button, CircularProgress, FormControl, FormLabel, TextField, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { SignInErrorType } from "../../pages/Auth/reducer";

interface PassedProps {
    email: string;
    onSubmit: (code: string) => void;
    isLoading: boolean;
    errorType?: SignInErrorType;
}

const EnterOtpCodeStep = (props: PassedProps) => {

    const [codeError, setCodeError] = React.useState(false);
    const [codeErrorMessage, setCodeErrorMessage] = React.useState('');

    React.useEffect(() => {
        if (props.errorType && props.errorType === SignInErrorType.incorrectCredentials) {
            setCodeError(true);
            setCodeErrorMessage('Incorrect OTP code.');
        }
    }, [props.errorType])

    const validateInputs = () => {
        const code = document.getElementById('code') as HTMLInputElement;

        let isValid = true;

        if (!code.value) {
            setCodeError(true);
            setCodeErrorMessage('Please enter a valid email address.');
            isValid = false;
        } else {
            setCodeError(false);
            setCodeErrorMessage('');
        }

        return isValid;
    };

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        if (codeError) {
            return;
        }

        const data = new FormData(event.currentTarget);

        props.onSubmit(data.get('code') as string);
    };

    return <>
        <Typography
            component="h1"
            variant="h4"
            sx={{ width: '100%', fontSize: 'clamp(2rem, 10vw, 2.15rem)' }}
        >
            Confirm Email
        </Typography>
        <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}
        >
            <span>OTP code sent to the email <b>{props.email}</b></span>
            <FormControl>
                <FormLabel htmlFor="code">Please enter the verification code</FormLabel>
                <TextField
                    autoComplete="code"
                    name="code"
                    required
                    fullWidth
                    id="code"
                    placeholder="111111"
                    error={codeError}
                    helperText={codeErrorMessage}
                    color={codeError ? 'error' : 'primary'}
                />
            </FormControl>
            <Button
                type="submit"
                fullWidth
                variant="contained"
                onClick={validateInputs}
                disabled={props.isLoading}
            >
                {props.isLoading ? (
                    <CircularProgress
                        size={24}
                        style={{
                            color: "white",
                            position: "absolute",
                        }}
                    />
                ) : (
                    "Submit"
                )}
            </Button>
        </Box>
    </>
}

export default EnterOtpCodeStep;